/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Point_Response_TitleInputs */

const en_contact_point_response_title = /** @type {(inputs: Contact_Point_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A reply within one business day`)
};

/**
* | output |
* | --- |
* | "A reply within one business day" |
*
* @param {Contact_Point_Response_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_point_response_title = /** @type {((inputs?: Contact_Point_Response_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Point_Response_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_point_response_title(inputs)
});